import React, {Fragment, useContext, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {IbmMessageHistoryButton, IbmMessageHistoryModal, TextChatMessageList} from 'components';
import {ACTIVITY_NAME_TRANSLATE} from 'constants/session';
import {UserSessionContext} from 'context';
import {useUserSession} from 'hooks';
import {SessionActivityName} from 'interfaces';
import {sessionUtils} from 'utils';

import {SidebarView} from '../../types';
import {SidebarContent} from '../SidebarContent';

export const SipHistorySidebar: React.FC = () => {
    const {t} = useTranslation();

    const [ibmIntegrationModalOpen, setIbmIntegrationModalOpen] = useState(false);

    const {session} = useContext(UserSessionContext);
    const {sipActivity, prevSipActivity, userParticipantIdGroups, participants} = useUserSession();
    const currentSipActivity = useMemo(() => sipActivity || prevSipActivity, [prevSipActivity, sipActivity]);

    const localParticipantId = useMemo(() => session?.localParticipant.id, [session]);

    const messages = useMemo(() => sessionUtils.getTextChatActivityMessages(currentSipActivity?.data?.threads), [currentSipActivity]);

    const ibmSessionHistoryKey = useMemo(() => currentSipActivity?.data?.integrations?.ibm?.sessionHistoryKey, [currentSipActivity]);

    return (
        <SidebarContent
            view={SidebarView.SIP}
            header={<div className='tw-ts-h5'>{t(ACTIVITY_NAME_TRANSLATE[SessionActivityName.SIP])}</div>}
        >
            <div className='vs-session-text-chat tw-mt-4 tw-pr-4 tw-h-full'>
                {ibmSessionHistoryKey && (
                    <Fragment>
                        <IbmMessageHistoryModal
                            open={ibmIntegrationModalOpen}
                            sessionHistoryKey={ibmSessionHistoryKey}
                            onClose={() => setIbmIntegrationModalOpen(false)}
                        />
                        <IbmMessageHistoryButton className='tw-mb-4' onClick={() => setIbmIntegrationModalOpen(true)} />
                    </Fragment>

                )}
                <div className='tw-pb-4'>
                    <TextChatMessageList
                        messages={messages}
                        participants={participants}
                        localParticipantId={localParticipantId}
                        userParticipantIds={userParticipantIdGroups}
                        downloadFile={() => null}
                        messagesEndRef={null}
                        downloadingFiles={[]}
                        typingRemoteParticipantIds={[]}
                        hideEmptyMessagesLabel={!!ibmSessionHistoryKey}
                        downloadFileDisabled
                    />
                </div>
            </div>
        </SidebarContent>
    );
};